import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ListPage from "@/views/ListPage"
import DetailPage from "@/views/DetailPage"
import Login from "@/views/admin/Login"
import AdminHome from "@/views/admin/AdminHome"
import AdminArticle from "@/views/admin/AdminArticle"
import DetailPageAdmin from "@/views/admin/DetailPageAdmin"
import AdminPassword from "@/views/admin/AdminPassword"

let routes;
routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/guoNeiZiXun',
    name: 'guoNeiZiXun',
    component: ListPage
  },
  {
    path: '/guoWaiZiXun',
    name: 'guoWaiZiXun',
    component: ListPage
  },
  {
    path: '/zuiXinZiXun',
    name: 'zuiXinZiXun',
    component: ListPage
  },
  {
    path: '/hangYeZiXun',
    name: 'hangYeZiXun',
    component: ListPage
  },
  {
    path: '/shiShiXinWen',
    name: 'shiShiXinWen',
    component: ListPage
  },
  {
    path: '/detail',
    name: 'detail',
    component: DetailPage
  },
  {
    path: '/AdminLogin',
    name: 'loginPage',
    component: Login
  },
  {
    path: '/AdminHome',
    name: 'adminHome',
    component: AdminHome
  },
  {
    path: '/AdminArticle',
    name: 'adminArticle',
    component: AdminArticle
  },
  {
    path: '/DetailPageAdmin',
    name: 'detailPageAdmin',
    component: DetailPageAdmin
  },
  {
    path: '/AdminPassword',
    name: 'adminPassword',
    component: AdminPassword
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
